import React from "react"
import { Table } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { RoleCard } from "./RoleCard"
import { PARTNER_USERS, ROLES_TITLE } from "@src/api"

interface UsersTableProps {
  userRoles: PARTNER_USERS[]
}

const TABLE_COLUMNS = ["users", "email", "roles", "actions"]
const ROLES = [
  { key: ROLES_TITLE.role_admin, value: "Admin" },
  { key: ROLES_TITLE.role_manager, value: "Manager" },
]

export const UsersTable: React.FC<UsersTableProps> = ({ userRoles }) => {
  const { t } = useTranslation()

  const getRoleDisplayName = (roleKey: ROLES_TITLE) => {
    return ROLES.find((role) => role.key === roleKey)?.value || roleKey
  }

  return (
    <Table responsive>
      <thead>
        <tr style={{ whiteSpace: "nowrap" }}>
          {TABLE_COLUMNS.map((item) => (
            <th key={item}>
              <div className="d-flex flex-row align-items-center">
                {item !== "actions" ? t(`settings.partner.${item}`) : ""}
              </div>
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {/* Users */}
        {userRoles.map((userRole) =>
          userRole.users?.map((user) => (
            <tr key={`${userRole.name}-${user.id}`} style={{ whiteSpace: "nowrap" }}>
              <td>
                <label>
                  {user.firstname} {user.lastname}
                </label>
              </td>
              <td>
                <label>{user.email}</label>
              </td>
              <td>
                <RoleCard text={getRoleDisplayName(userRole.name)} />
              </td>
              <td>{/* Empty cell for users - no actions available */}</td>
            </tr>
          )),
        )}
      </tbody>
    </Table>
  )
}
